<template>
  <WhiteIQOS
    :title="$t('reserve_deposit_settings.title')"
    :subtitle="$t('reserve_deposit_settings.subtitle')"
    :enabled="depositEnabled"
    bodyClass="gap-row-sm deposit-settings-iqos"
  >
    <BaseBetaRadioButton size="lg" v-model="depositType" checkedValue="full">
      {{ $t("reserve_deposit_settings.mode_full") }}
    </BaseBetaRadioButton>

    <BaseDivider color="border-base-tertiary" />

    <div class="gap-row-xs">
      <BaseBetaRadioButton
        size="lg"
        v-model="depositType"
        checkedValue="constant"
      >
        {{ $t("reserve_deposit_settings.mode_constant") }}
      </BaseBetaRadioButton>

      <BaseNumberInput
        v-model.number="depositValue"
        placeholder="0"
        @blur="save"
        :disabled="depositType != 'constant'"
        :unit="currency.symbol"
        size="md"
      />
    </div>

    <BaseDivider color="border-base-tertiary" />

    <div class="gap-row-xs">
      <BaseBetaRadioButton
        size="lg"
        v-model="depositType"
        checkedValue="percent"
      >
        {{ $t("reserve_deposit_settings.mode_percent") }}
      </BaseBetaRadioButton>

      <BaseNumberInput
        v-model.number="depositPercent"
        placeholder="0"
        @blur="save"
        unit="%"
        :disabled="depositType != 'percent'"
        size="md"
      />
    </div>

    <template #actions>
      <BaseToggleSwitcher
        size="lg"
        fillBg="background-success-default"
        disabledBg="background-base-inverse-primary"
        :value="depositEnabled"
        @input="(v) => (depositEnabled = !depositEnabled)"
      ></BaseToggleSwitcher>
    </template>
  </WhiteIQOS>
</template>

<script>
export default {
  data() {
    return {
      depositEnabled: false,
      depositType: "full",
      depositValue: null,
      depositPercent: null,

      wasReset: false,
    };
  },
  watch: {
    depositEnabled() {
      this.save();
    },
    depositType() {
      this.save();
    },
  },
  methods: {
    reset() {
      this.depositEnabled = this.cafe.reserve.deposit_enabled || false;
      this.depositType = this.cafe.reserve.deposit_type || "full";
      this.depositPercent = this.cafe.reserve.deposit_percent || null;
      this.depositValue = this.cafe.reserve.deposit_value || null;

      this.wasReset = true;
    },
    save() {
      if (!this.wasReset) return;

      this.$store.commit("setReserveDepositSettings", {
        value: this.depositValue,
        percent: this.depositPercent,
        type: this.depositType,
        enabled: this.depositEnabled,
      });
      this.$store.dispatch('saveCafe');
    },
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    },
    currency() {
      return this.$store.state.currency;
    },
  },
  mounted() {
    this.reset();
  },
};
</script>

<style>
.deposit-settings-iqos {
  padding: 24px !important;
}
</style>
